module.exports = __webpack_public_path__ + "img/logo.852ccf4f.svg";